function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { genComponentStyleHook } from "../../_util/genComponentStyleHook";
import { genLargeStyle } from "../../_util/genStyle";
export var genEmptyStyle = function genEmptyStyle(token) {
  var antCls = token.antCls,
    componentCls = token.componentCls,
    colorTextTertiary = token.colorTextTertiary,
    colorText = token.colorText,
    colorTextSecondary = token.colorTextSecondary;
  return _defineProperty(_defineProperty(_defineProperty({}, "".concat(componentCls), _defineProperty(_defineProperty(_defineProperty({}, "".concat(componentCls, "-image"), {
    height: 160,
    marginBottom: 0
  }), "".concat(componentCls, "-description"), _defineProperty(_defineProperty(_defineProperty({
    // ensure description content color is correct always
    color: colorTextTertiary
  }, "".concat(componentCls, "-title"), {
    color: token.colorText,
    fontWeight: token.fontWeightStrong,
    fontSize: token.fontSizeHeading4,
    lineHeight: token.lineHeightHeading4,
    marginTop: token.marginLG
  }), "".concat(componentCls, "-description-content"), {
    color: colorTextTertiary,
    maxWidth: 600,
    margin: '0px auto',
    marginTop: token.marginXS
  }), "".concat(antCls, "-steps"), _defineProperty({
    maxWidth: 1000,
    margin: '0px auto',
    marginTop: token.marginLG,
    padding: token.paddingLG,
    backgroundColor: token.colorFillQuaternary,
    borderRadius: token.borderRadiusLG
  }, "".concat(antCls, "-steps-item-container"), _defineProperty(_defineProperty({}, "".concat(antCls, "-steps-item-icon"), _defineProperty({
    height: token.controlHeightSM,
    width: token.controlHeightSM,
    lineHeight: "".concat(token.controlHeightSM, "px"),
    backgroundColor: token.colorFillSecondary,
    // override default border color
    borderColor: token.colorFillSecondary
  }, "".concat(antCls, "-steps-icon"), {
    color: colorTextSecondary,
    fontSize: token.fontSize
  })), "".concat(antCls, "-steps-item-content"), _defineProperty(_defineProperty({}, "".concat(antCls, "-steps-item-title"), {
    color: colorText,
    fontSize: token.fontSize,
    fontWeight: token.fontWeightStrong,
    lineHeight: "".concat(token.controlHeightSM, "px"),
    '&::after': {
      top: token.controlHeightSM / 2
    }
  }), "".concat(antCls, "-steps-item-description"), {
    color: colorTextTertiary,
    fontSize: token.fontSizeSM,
    marginTop: token.marginXS
  }))))), "".concat(componentCls, "-footer"), _objectSpread({
    marginTop: token.marginLG
  }, genLargeStyle(token)))), "".concat(componentCls, "-horizontal"), _defineProperty({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }, "".concat(componentCls, "-description"), _defineProperty(_defineProperty({
    marginLeft: token.marginXXL,
    textAlign: 'left'
  }, "".concat(componentCls, "-title"), {
    marginTop: 0
  }), "".concat(componentCls, "-description-content"), {
    marginTop: token.margin
  }))), "".concat(componentCls, "-small"), _defineProperty({}, "".concat(componentCls, "-image"), {
    height: 54
  }));
};
export default (function (prefixCls) {
  var useStyle = genComponentStyleHook('Empty', function (token) {
    return [genEmptyStyle(token)];
  });
  return useStyle(prefixCls);
});